export default __webpack_public_path__ + "static/media/plain-sticker-yo.976bd352.png";